import React from 'react'

const Salarie = ({handleChange,values}) => {
    const getEtat = ()=>{
        return values.salarieInformatique?"checked":"";
    }
    if (values.idSituation =="121152")
    {
        return (            
            <div class="d-flex text-center mt-5">
                <input class="mx-custom-10" type="checkbox" checked={getEtat()} onChange={handleChange("salarieInformatique")}/>  
                <label>Salarié&middot;e en informatique ?</label>
            </div>
        )
    }else{
        return <></>
    }
}

export default Salarie